import { IconProps } from "@models/types";

interface Props extends IconProps {
  number?: number;
}

export function CartMobileIcon({ className, height, width, number }: Props) {
  return (
    <>
      <svg
        className={className}
        width={width}
        height={height}
        id="Layer_1"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
      >
        <defs></defs>
        <g id="Path_140" data-name="Path 140">
          <path d="m3.46,5.63l-2.14,13.2h17.36l-2.14-13.2H3.46m-.83-.96h14.74l2.46,15.13H.18L2.63,4.67Z" />
          <polygon points="19.17 19.17 .98 19.17 3.09 5.22 16.86 5.22 19.17 19.17" />
          <text
            x="50%"
            y="50%"
            dominantBaseline="middle"
            textAnchor="middle"
            dy=".3em"
            className="font-chivo-regular text-[10px]"
            fill="white"
          >
            {number}
          </text>
        </g>

        <path
          d="M5.32,7.49H5.27A.49.49,0,0,1,4.82,7c0-.28.62-6.75,5.23-6.75S15.27,6.67,15.29,7a.5.5,0,1,1-1,.08c0-.06-.52-5.83-4.24-5.83S5.82,7,5.81,7A.5.5,0,0,1,5.32,7.49Z"
          fill="black"
        />
      </svg>
    </>
  );
}